import type { CartCreationResponse } from '@/app/api/hotel-detail/cart-creation/route';
import type { InitialParams } from '@/app/components/hotel-detail/InitialParamsProvider';
import { getActionId } from '@/app/components/hotel-detail/lib/tracking';

export const BLOCKING_ERROR_SHOWN = 'BLOCKING_ERROR_SHOWN';
export const BLOCKING_ERROR_SHOWN_VERSION = '1.0';

export type BlockingErrorShownPayload = {
  actionId: string;
  cartId: string;
  error: string;
  productDetailKey: string;
  searchId: string;
};

export type BlockingErrorShownParams = {
  initialParams: Pick<InitialParams, 'actionIdSeed' | 'productDetailKey'>;
  searchId: string | undefined;
  cartCreationResponse: CartCreationResponse;
};

export const createBlockingErrorShownPayload = ({
  initialParams,
  searchId,
  cartCreationResponse,
}: BlockingErrorShownParams): BlockingErrorShownPayload => ({
  actionId: getActionId(initialParams.actionIdSeed, searchId),
  cartId: cartCreationResponse.cartId || '',
  // errorType is only optional in the response's general shape; both call sites only invoke this
  // when errorType is truthy, so the fallback is unreachable in practice.
  error: cartCreationResponse.errorType ?? '',
  productDetailKey: initialParams.productDetailKey,
  searchId: searchId || '',
});
